export default "__VITE_ASSET__CKQF_z79__"